<template>
  <div class="credentials">
    <div class="title" v-if="meunList.length > 0 && !isWihite">
      <span>{{$t('credentials_填写认证资料')}}</span>
    </div>
    <div :style="{display: hasDoc ? 'flex' : '', justifyContent: ([0, 2].includes(subjectStatus) && hasDoc) ? 'end' : ''}" v-if="meunList.length">
      <div class="top-tips" v-show="meunList.length > 0 && isWihite && subjectStatus === 3 || subjectStatus === 1" :style="{ width: hasDoc ? '' : '100%' }">
        <svg-icon style="font-size: 14px;margin-right: 8px;" iconfont name="open-icon-Info"></svg-icon>
        {{$t('credentials_若认证资料审核不通过或有变更时，请点击')}}<a @click="handleOk" style="text-decoration:underline;">{{$t('credentials_重新认证')}}</a>{{$t('credentials_重新提交')}}
      </div>
      <content-title :style="{ display: hasDoc ? '' : 'none', width: hasDoc ? '55px' : '' }" @done="hasDocument" v-if="toShen === 0"></content-title>
    </div>

    <!-- 使用平台前请完成企业认证流程-->
    <div class="credentials-seccess-ok" v-if="meunList.length && subjectStatus === 0 && toShen === 0">
      <img width="153" height="157" src="@/assets/noPermission.svg" alt="" />
      <span class="title1">{{$t('credentials_资质认证')}}</span>
      <div class="credentials-bes" style="margin-bottom: 24px;">{{personalData && personalData.boughtErp === 1 ? $t('credentials_创建第三方应用前请先完成资质认证') : $t('credentials_使用平台前请完成企业认证流程')}}</div>
      <a-button class="credentials-btn" @click="toReg(3)" type="primary">
        {{$t('credentials_个人认证')}}
        <img src="@/assets/cre_btn1.png"/>
      </a-button>
      <a-button class="credentials-btn" style="background: rgba(7, 123, 252, 0.06);border: 1px solid #077BFC;margin-left: 12px;color: #077BFC;" @click="toReg(1)" type="primary">
        {{$t('credentials_企业认证')}}
        <img src="@/assets/cre_btn2.png"/>
      </a-button>
    </div>

    <!-- 已提交列表 -->
    <div v-if="meunList.length > 0 && (subjectStatus === 3 || subjectStatus === 1)">
      <div v-primission="'OPEN_API_QUALIFICATION_MATERIAL'">
        <smart-table
          ref="smartTable"
          :base-url="baseURL"
          :api-path="apiPath"
          :param="param"
          :columns="columns"
          :bordered="false"
          :row-key="(record, index) => index"
          :scroll="{ y: 600 }"
        >
          <template slot="num" slot-scope="text, record, index">
            <span>{{(($refs.smartTable.pagination.current - 1) * $refs.smartTable.pagination.pageSize) + (index + 1)}}</span>
          </template>

          <template slot="subjectStatus" slot-scope="text">
            <!-- <i v-show="text === 0">{{$t('credentials_待审核')}}</i> -->
            <div style="display: flex;align-items: center;" v-if="text === 1">
              <div class="statusColor" style="background: #52C41A;"></div>
              <i>{{$t('credentials_已通过')}}</i>
            </div>
            <div style="display: flex;align-items: center;" v-if="text === 2">
              <div class="statusColor" style="background: red;"></div>
              <i v-show="text === 2">{{$t('credentials_已打回')}}</i>
            </div>
            <!-- <i v-show="text === 2">{{$t('credentials_已打回')}}</i> -->
            <div style="display: flex;align-items: center;" v-if="text === 3">
              <div class="statusColor"></div>
              <i v-show="text === 3">{{$t('credentials_审核中')}}</i>
            </div>
          </template>
        </smart-table>
      </div>
    </div>

    <!-- 填写 -->
    <template v-if="[0, 2].includes(subjectStatus) && [1, 3].includes(toShen)">
      <div class="credentials-align" :style="{ marginLeft: '48px' }">
        <div>
          <span class="item-title"><i>*</i>{{$t('credentials_认证方式')}}：</span>
          <a-radio-group v-model="toShen">
            <a-radio :value="3">
              {{$t('credentials_个人认证')}}
            </a-radio>
            <a-radio :value="1">
              {{$t('credentials_企业认证')}}
            </a-radio>
          </a-radio-group>
        </div>
      </div>
      <CompanyCertification @backToTab="backToTab" @submit="_SsoGetUserInfo" v-if="toShen === 1" />
      <PersonCertification @backToTab="backToTab" @submit="_SsoGetUserInfo" v-else-if="toShen === 3"></PersonCertification>
    </template>

    <!-- 提交成功 -->
    <div class="credentials-seccess-ok" v-if="toShen === 2">
      <img width="100" height="100" src="@/assets/success.svg" alt="" />
      <div class="credentials-seccess-titel">{{$t('common_submint_seccess')}}</div>
      <div class="credentials-seccess-content">{{$t('credentials_系统将会尽快审核您的资料')}}</div>
      <a-config-provider :auto-insert-space-in-button="false">
        <a-button class="credentials-btn" @click="backToTab" style="margin-top: 24px;" type="primary">
          {{$t('credentials_资质管理按钮')}} ({{timesLater}}s{{$t('credentials_后自动跳转')}})
        </a-button>
      </a-config-provider>
    </div>

    <!-- 打回 -->
    <div class="credentials-seccess-ok" v-if="subjectStatus === 2 && toShen === 0">
      <img width="160" height="138" src="@/assets/fail.svg" alt="" />
      <div class="fail">认证被打回</div>
      <i18n class="credentials-bes" path="credentials_您的认证资料由于" tag="div" style="margin-bottom: 24px;color: rgba(0, 0, 0, 0.45);">
        <template v-slot:Desc>
          <i>{{statusDesc}}</i>
        </template>
      </i18n>
      <a-button class="credentials-btn" @click="toReg(3)" type="primary">
        {{$t('credentials_个人认证')}}
        <img src="@/assets/cre_btn1.png"/>
      </a-button>
      <a-button class="credentials-btn" style="background: rgba(7, 123, 252, 0.06);border: 1px solid #077BFC;margin-left: 12px;color: #077BFC;" @click="toReg(1)" type="primary">
        {{$t('credentials_企业认证')}}
        <img src="@/assets/cre_btn2.png"/>
      </a-button>
    </div>

    <!-- 无权限页面 -->
    <NoPermission v-if="meunList.length === 0"/>

  </div>
</template>
<script>
import moment from 'moment'
import { SsoGetSubjectAuthentications, SsoGetUserInfo } from '@/api/login'
import { openNotificationWithIcon } from '@/utils/util'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { mapState, mapGetters } from 'vuex'
import PersonCertification from './components/PersonCertification.vue'
import NoPermission from './components/noPermission.vue'
import CompanyCertification from './components/companyCertification'
import api from '@/api/index'
import SmartTable from '@/components/SmartTable_next'
import ContentTitle from '@/components/ContentTitle.vue'

export default {
  name: 'Credentials',
  components: {
    PersonCertification,
    NoPermission,
    CompanyCertification,
    ContentTitle,
    SmartTable
  },
  data () {
    return {
      uesrName: '',
      disabled: false,
      updateTime: '',
      isConfirm: 0, // 认证状态
      statusDesc: '', // 原因
      toShen: 0, // 0: 初始状态；1：企业认证；2：已提交；3：个人认证
      subjectStatus: 0, // 审核状态0：待审核，1：已审核，2：已打回
      isWihite: true,
      authenticationType: 2,
      headers: {
        Authorization: this.$ls.get(ACCESS_TOKEN)
      },
      cerVisible: false, // 选择认证方式弹窗
      credentialsType: 3,
      timesLater: 0,
      timer: undefined,
      baseURL: '',
      apiPath: api.SsoGetSubjectAuthentications,
      param: {},
      columns: [
        { title: 'No.', key: 'num', dataIndex: 'num', scopedSlots: { customRender: 'num' }, align: 'left', width: 90 },
        { title: this.$t('credentials_提交时间'), key: 'commitTime', dataIndex: 'commitTime', customRender: text => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-', align: 'left', width: 200 },
        { title: this.$t('common_conj_type'), key: 'authenticationType', dataIndex: 'authenticationType', customRender: text => text ? text === 1 ? this.$t('credentials_个人') : this.$t('credentials_企业') : '-', align: 'left', width: 150 },
        { title: this.$t('childAct_状态'), key: 'subjectStatus', dataIndex: 'subjectStatus', scopedSlots: { customRender: 'subjectStatus' }, align: 'left', width: 160 }
      ],
      hasDoc: false // 是否有帮助文档
    }
  },
  computed: {
    ...mapState({
      currentLang: state => state.isLogin.lang,
      'subjectId': state => state.isLogin.subjectId,
      'meunList': state => state.isLogin.meunList,
      'pagePrimission': state => state.isLogin.pagePrimission
    }),
    ...mapGetters(['personalData']),
    handleTitle () {
      const menuInfo = this.meunList.find(item => item.menuUrl === this.$route.path)
      return this.currentLang === 'zh_CN' ? menuInfo && menuInfo.menuName : menuInfo && menuInfo.menuEnName
    }
  },
  watch: {
    subjectId: {
      handler () {
        this.coreGetCompany()
      }
    }
  },
  created () {
    this.coreGetCompany()
    console.log('this.subjectId', this.subjectId)
  },
  methods: {
    moment,
    coreGetCompany () {
      SsoGetSubjectAuthentications({
        // subjectId: this.subjectId ? this.subjectId : ''
      }).then((res) => { // 根据主体区查询认证、审核状态
        const { code, message, dataList } = res
        if (code === '200') {
          if (dataList.length !== 0) {
            this.$store.commit('SET_COMPANY_INFO', dataList[0]) // Vuex存储个人认证信息
            this.$store.dispatch('_SET_TO_OTHERMENU', (dataList || [])) // 判断是否能够进入其他菜单
            this.authenticationType = dataList[0].authenticationType || 2 // 认证类型
            this.toShen = 0
            this.updateTime = dataList[0].updateTime
            if (dataList[0].isConfirm === 0) { // 未审核
              this.isConfirm = 0
            } else {
              this.isConfirm = 1
            }
            if (dataList[0].subjectStatus === 0) { // 待审核
              this.subjectStatus = 0
            } else if (dataList[0].subjectStatus === 1) { // 已审核
              this.subjectStatus = 1
            } else if (dataList[0].subjectStatus === 2) { // 已打回
              this.subjectStatus = 2
              this.statusDesc = dataList[0].statusDesc
            } else if (dataList[0].subjectStatus === 3) { // 审核中
              this.subjectStatus = 3
            } else {
              this.subjectStatus = 0
            }
            if (this.meunList.length > 0 && (this.subjectStatus === 3 || this.subjectStatus === 1) && this.pagePrimission['OPEN_API_QUALIFICATION_MATERIAL']) {
              this.$nextTick(() => {
                this.$refs.smartTable.fetch()
              })
            }
          } else {
            this.subjectStatus = 0
            this.toShen = 0
          }
        } else {
          openNotificationWithIcon(message)
        }
      })
    },
    backToTab () {
      this.isWihite = true
      this.coreGetCompany()
    },
    hasDocument () {
      this.hasDoc = true
    },
    // 获取注册主体信息
    _SsoGetUserInfo () {
      console.log('this.subjectId', this.subjectId)
      this.toShen = 2
      this.timesLater = 3
      this.timer = setInterval(() => {
        if (this.timesLater === 0) {
          clearInterval(this.timer)
          return this.backToTab()
        }
        this.timesLater -= 1
      }, 1000)
      // 重新获取用户信息
      SsoGetUserInfo().then(res => {
        if (res.code === '200') {
          this.$store.commit('SET_SUBJECT_NAME', res.data.onlineSubjectName)
          this.$store.commit('USER_INFO', res.data)
          if (res.data.userType === 0) { // 此时登录后，需要去认证 弹窗
            this.$store.commit('SET_IS_CREDENTIALS', true)
          } else {
            this.$store.commit('SET_IS_CREDENTIALS', false)
          }
          if (this.subjectId !== res.data.onlineSubjectId) {
            this.$store.commit('SET_SUBJECT_ID', res.data.onlineSubjectId)
          }
        } else {
          openNotificationWithIcon(res.message)
        }
      })
      this.isWihite = true
    },
    toReg (type) {
      this.toShen = type
      this.isWihite = false
    },
    handleOk () {
      console.log('subjectStatus', this.subjectStatus)
      if (this.subjectStatus === 3) {
          const that = this
          this.$info({
          title: that.$t('common_globalcomp_warm_prompt'),
          content: that.$t('developer_当前资料正在审核中，不支持重复发起认证'),
          onOk () {},
          okText: this.$t('common_btn_i_know')
        })
        return
      }
      this.subjectStatus = 0
      this.toShen = this.authenticationType === 1 ? 3 : this.authenticationType === 2 ? 1 : ''
      this.isConfirm = 0
      this.isWihite = false
      this.cerVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
.credentials {
  width: 100%;
  position: relative;
  text-align: left;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.85);
  font-family: MicrosoftYaHei;
  padding: 12px;
  .title {
    display: flex;
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    padding-left: 8px;
    height: 18px;
    margin-bottom: 16px;
    border-left: 3px solid #4978D6;
  }
  .item-title {
    min-width: 82px;
    text-align: right;
    font-size: 12px;
    // margin-left: 17px;
    margin-right: 12px;
    display: inline-block;
    i {
      color: #E02020;
    }
    .item-opt {
      font-size: 14px;
      margin-left: 20px;
    }
  }
  .content {
    width:1107px;
    margin:0 auto;
    margin-top:28px;
    line-height:36px;
    font-size:18px;
    padding-bottom: 47px;
    margin-bottom: 47px;
  }
}
.credentials-align {
  display:flex;
  align-items: center;
  margin-bottom: 18px;
}
.credentials-btn {
  min-width: 92px;
  height: 30px;
  background: #077BFC;
  border-radius: 2px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  img {
    margin-left: 8px;;
  }
}
.top-tips {
  width: 100%;
  height: 30px;
  background: rgba(0, 158, 255, 0.07);
  border: 1px solid rgba(0, 158, 255, 0.5);
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 2px;
  margin-bottom: 12px;
}
.statusColor {
  width: 5px;
  height: 5px;
  background: #077BFC;
  border-radius: 50%;
  margin-right: 5px;
}
.app-ul {
  // margin-right: 24px;
  // min-height: 500px;
  .app-li {
    font-size:0px;
    color: #555555;
    border-bottom: 1px solid rgba(240,240,240,1);
    span {
      font-size:12px;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 4px;
      &:nth-child(1) {
        width: 240px;
        border-right: 1px solid #fff;
      }
      &:nth-child(2) {
        width: 140px;
        border-right: 1px solid #fff;
      }
      &:nth-child(3) {
        width: 300px;
        border-right: 1px solid #fff;
      }
      &:nth-child(4) {
        width: 123px;
        i {
          font-style:normal;
        }
      }
    }
  }
}
.a-row-tips {
  display: flex;
  position: relative;
  width: 100%;
  height: auto;
  line-height: 28px;
  font-size: 14px;
  left: 0;
  top: 0;
  background: #E7F7FF;
  border: 1px solid #C3E6FF;
  padding: 5px 12px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 12px;
  ul {
    position: relative;
    left: -20px;
  }
  ul, dl {
    margin-bottom: 0;
  }
  span {display: inline-block; vertical-align: top; text-indent: 0.3em;}
}
.up-tips {
  font-weight:400;
  color:#555555;
  font-size:12px;
  margin-top: 15px;
  margin-bottom: 16px;
  i {
    color: #E02020;
  }
}
.ant-upload-picture-card-wrapper {
  display: flex;
}
.login-btn {
  width:auto;
  height:30px;
  font-size: 14px;
  margin-top: 22px;
  margin-left: 94px;
  background: #4978d6;
}
.credentials-notice {
  font-size: 12px;
  margin-left: 10px;
  color: #888;
  i {
    cursor: pointer;
    color: #E02020;
    font-style:normal;
  }
}
.credentials-seccess-ok {
  text-align: center;
  padding-top: 120px;
  .title1 {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    display: block;
    margin: 24px 0 12px;
  }
}
.credentials-seccess-titel {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  margin-top: 23px;
}
.credentials-seccess-content {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 12px;
}
.credentials-bes {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  i {
    font-style: normal;
    color: #4978D6;
  }
}
.credentials_visit {
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  color: #666666;
  margin-top: calc(100vh/4);
  img {
    width: 300px;
  }
  .credentials_visit_tips {
    padding-top: 5px;
  }
}
.fail {
  margin: 22px 0 12px 0;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
}
</style>
